// Copyright (c) 2026 杨翔宇（武汉文理学院）
// 物理智能教学智能体平台 (Physics Intelligent Agent)
// 保留所有权利 (All Rights Reserved)。未经著作权人书面许可，
// 不得以任何形式复制、传播、修改或用于商业用途。

import { useEffect, useRef } from 'react';

export interface LatticeLoaderProps {
  label?: string;
  className?: string;
}

/**
 * 洛伦兹轨迹加载器（Lattice Loader）：一条洛伦兹轨迹以渐隐点尾缓慢旋转。
 * 用作懒加载/等待态的视觉；`role="status"` 与 aria-label 由库写入。
 */
export default function LatticeLoader({ label = '加载中', className }: LatticeLoaderProps) {
  const hostRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = hostRef.current;
    if (!el) return undefined;
    let disposed = false;

    void (async () => {
      try {
        const { mountLoader } = await import('@/vendor/lattice/dom/dottext.js');
        if (disposed) return;
        mountLoader(el, { n: 700 });
      } catch {
        // jsdom / 无 canvas：保留空容器（等待态不影响可用性）
      }
    })();

    return () => {
      disposed = true;
    };
  }, [label]);

  return <div ref={hostRef} className={className} aria-label={label} />;
}
